const saskiaSchlemmerTheme = {
  palette: {
    primary: {
      main: "#8A703D",
      dark: "#086662",
    },
    secondary: {
      main: "#F254E5",
    },
  }
};

export default saskiaSchlemmerTheme;
